import Vue from 'vue';
import VueSweetAlert from 'vue-sweetalert2';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import VModal from 'vue-js-modal';
import SimpleVueValidation from 'simple-vue-validator';
import VueSelect from 'vue-select';
import 'vuetify/dist/vuetify.min.css';
import CoreuiVue from '@coreui/vue'

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

const vuetifyOptions = {
  theme: {
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  icons: {
    iconfont: 'fa',
  },
};

Vue.use(Vuetify);

import App from "./App.vue";
import router from "./router";
import { unregisterServiceWorker } from "./registerServiceWorker";

import CKEditor from "@ckeditor/ckeditor5-vue";

import Loading from "@/components/Loading";
import LoadingMessage from "@/components/LoadingMessage";
import LogAlteracaoDados from "@/components/Log/LogAlteracaoDados";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./components/icons";
import "sweetalert2/dist/sweetalert2.min.css";

unregisterServiceWorker();

Vue.config.productionTip = false;

import { VuejsDatatableFactory } from "vuejs-datatable";
Vue.use(VuejsDatatableFactory);

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import money from "v-money";
Vue.use(money, { precision: 2 });

import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);

import InputPercent from "./components/InputPercent";
Vue.use(InputPercent);

import InputMoney from "./components/InputMoney";
Vue.use(InputMoney);

import InputDatePicker from "./components/InputDatePicker";
Vue.use(InputDatePicker);

import ImagePicker from "./components/ImagePicker";
Vue.use(ImagePicker);

import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

import GridCardPlugin from "./components/grid-card";
Vue.use(GridCardPlugin);

import JsonEditor from "vue-json-edit";
Vue.use(JsonEditor);

import vueNcform from '@ncform/ncform';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ncformStdComps from '@ncform/ncform-theme-elementui';
// import FormColorPicker from './components/form/FormColorPicker';
import FormInputColorPicker from './components/form/FormInputColorPicker';
import FormInputIconPicker from './components/form/FormInputIconPicker';
import Codeblock from './components/form/ncform/Codeblock';
import Jsonblock from './components/form/ncform/Jsonblock';
import WidgetTipo from './components/form/ncform/WidgetTipo';
import Topicos from './components/form/ncform/Topicos';
import ConditionBuilder from './components/form/ncform/ConditionBuilder';

Vue.use(Element);
Vue.use(vueNcform, {
  extComponents: Object.assign(ncformStdComps, {
    FormInputColorPicker,
    FormInputIconPicker,
    Codeblock,
    Jsonblock,
    WidgetTipo,
    Topicos,
    ConditionBuilder,
    InputPercent,
    InputMoney,
    InputDatePicker,
    ImagePicker
  }),
  lang: 'pt-br'
});


import { iconsSet as icons } from './assets/icons/icons.js'

import VueMarkdown from "vue-markdown";

import { dateFilter, dateTimeFilter } from "./filters/dateFilter";
import { monetary } from "./filters/monetary";
import { boolean, booleanHtml } from "./filters/text";
import VueQRCodeComponent from 'vue-qrcode-component';
import SelectModelPicker from '../src/components/crud/SelectModelPicker';
import Thumb from '../src/components/base/Thumb.vue';

Vue.filter("date", dateFilter);
Vue.filter("datetime", dateTimeFilter);
Vue.filter("monetary", monetary);
Vue.filter("boolean", boolean);
Vue.filter("booleanHtml", booleanHtml);

Vue.use(VModal);
Vue.use(SimpleVueValidation);
Vue.use(VueSweetAlert);

Vue.use(CKEditor);
Vue.use(CoreuiVue);

// import "@/assets/css/style.css";
import "@/assets/css/components.css";

Vue.component('v-select', VueSelect);
Vue.component('Loading', Loading);
Vue.component('LoadingMessage', LoadingMessage);
Vue.component('LogAlteracaoDados', LogAlteracaoDados);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('input-percent', InputPercent);
Vue.component('vue-markdown', VueMarkdown);
Vue.component('qr-code', VueQRCodeComponent);
Vue.component('SelectModelPicker', SelectModelPicker);
Vue.component('thumb', Thumb);

// import '@/assets/css/style.css';
import '@/assets/css/components.css';

import config from './config'
import VueGtm from '@gtm-support/vue2-gtm';
Vue.use(
  VueGtm,
  {
    id: config.gtmToken,
    vueRouter: router,
  }
);

import configureApplication from "./configureApplication";
configureApplication(Vue);

window.swal = Swal;

const vuetify = new Vuetify(vuetifyOptions);

new Vue({
  router,
  icons,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
